<div ng-controller="TemplateController as templateCtrl" class="modal-view">
    <c-auto-form config="templateCtrl.autoFormConfig"></c-auto-form>
</div>
